<template>
    <div class="position-relative">
        <DCard
            padding
        >
            <PermissionForm
                ref="createForm"
                :errors="errors"
                :permission="permission"
                @submit="updatePermission"
            />
        </DCard>
    </div>
</template>

<script>
import PermissionForm from '~@/Components/Settings/Permissions/Form'

export default {

    name: 'PermissionEdit',
    components: {
        PermissionForm
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        permission: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        updatePermission (form) {
            this.$inertia.post(this.$route('settings.permissions.update', {
                id: form.id
            }), { ...form, _method: 'PUT' })
        }
    }
}
</script>
